module.exports = __webpack_public_path__ + "static/img/Tech_01.82c0b734.png";